import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, Typography } from '@mui/material';
import { InternshipLineItem } from './InternshipLineItem';
var _a = appStrings.modules.nugget.internship, BACKRS_ASSESSMENT = _a.BACKRS_ASSESSMENT, SECTION_TITLES = _a.SECTION_TITLES, notAvailable = _a.notAvailable;
export function BackrsAssessment() {
    var _a;
    var valueMap = (_a = {},
        _a[BACKRS_ASSESSMENT.growthPotential] = notAvailable,
        _a[BACKRS_ASSESSMENT.compensation] = notAvailable,
        _a[BACKRS_ASSESSMENT.intensity] = notAvailable,
        _a[BACKRS_ASSESSMENT.gpaRequirement] = notAvailable,
        _a[BACKRS_ASSESSMENT.achievementRequirement] = notAvailable,
        _a[BACKRS_ASSESSMENT.experienceRequirement] = notAvailable,
        _a[BACKRS_ASSESSMENT.technicalSkills] = notAvailable,
        _a);
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "body1", sx: sectionTitleStyle, children: SECTION_TITLES.backrsAssessment }), Object.entries(valueMap).map(function (_a) {
                var title = _a[0], value = _a[1];
                return (_jsx(InternshipLineItem, { title: title, value: value }, title));
            })] }));
}
var sectionTitleStyle = {
    fontWeight: 700,
    color: appColors.color.blue1,
    mb: 1,
};
